var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import HeadlineComponent from '../../Headline';
import styled from '../../utils/styled-components';
import getIconSet from '../../utils/getIconSet';
var StyledHeader = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-shrink: 0;\n  justify-content: space-between;\n  align-items: center;\n  background: ", ";\n  border-bottom: ", ";\n"], ["\n  display: flex;\n  flex-shrink: 0;\n  justify-content: space-between;\n  align-items: center;\n  background: ", ";\n  border-bottom: ", ";\n"])), function (_a) {
    var component = _a.theme.component;
    return component.modal.header.background;
}, function (_a) {
    var component = _a.theme.component;
    return component.modal.header.border;
});
var StyledButton = styled.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: ", ";\n  background-color: transparent;\n  border: none;\n  outline: none;\n  cursor: pointer;\n\n  &:active,\n  &:focus,\n  &:hover {\n    background: ", ";\n  }\n"], ["\n  padding: ", ";\n  background-color: transparent;\n  border: none;\n  outline: none;\n  cursor: pointer;\n\n  &:active,\n  &:focus,\n  &:hover {\n    background: ", ";\n  }\n"])), function (_a) {
    var component = _a.theme.component;
    return component.modal.button.padding;
}, function (_a) {
    var component = _a.theme.component;
    return component.modal.button.backgroundHighlight;
});
var Headline = styled(HeadlineComponent)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 0;\n  padding-left: ", ";\n\n  @media (min-width: ", ") {\n    font-size: 1.25rem;\n  }\n"], ["\n  margin: 0;\n  padding-left: ", ";\n\n  @media (min-width: ", ") {\n    font-size: 1.25rem;\n  }\n"])), function (_a) {
    var component = _a.theme.component;
    return component.modal.headline.padding;
}, function (_a) {
    var theme = _a.theme;
    return theme.global.breakpoints.desktop;
});
var _a = getIconSet(), ArrowLeft = _a.ArrowMediumLeft, Close = _a.Cancel;
/**
 * Header for the modal component
 * with a headline and a button for closing the modal
 */
var Header = function (_a) {
    var _b = _a.headline, headline = _b === void 0 ? '' : _b, onCloseClick = _a.onCloseClick, trackIdClose = _a.trackIdClose, testIdHeadline = _a.testIdHeadline, onBackClick = _a.onBackClick, trackIdBack = _a.trackIdBack, testIdBack = _a.testIdBack, testIdClose = _a.testIdClose;
    return (React.createElement(StyledHeader, null,
        onBackClick && (React.createElement(StyledButton, { "data-testid": testIdBack, "data-trackid": trackIdBack, onClick: function () { return onBackClick(); } },
            React.createElement(ArrowLeft, null))),
        React.createElement(Headline, { "data-testid": testIdHeadline, level: 4 }, headline),
        React.createElement(StyledButton, { "data-testid": testIdClose, "data-trackid": trackIdClose, onClick: onCloseClick },
            React.createElement(Close, null))));
};
export default Header;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map